<template>
  <div class="electroniContract_warpper">
    <navbar
      title="电子合同"
      :lefticon="lefticon"
      :lefticonheight="1.8"
      :lefticonwidth="1.8"
      :fontweight="700"
      :fontsize="'1.8rem'"
      @goback="goBack(false)"
    />
    <div class="contentBox">
      <div class="contract_informationBox">
        <p class="contract_title">合同信息</p>
        <p class="contract_information">
          合同名称：{{ dataSource.contract_name }}
        </p>
        <p class="contract_information">发起方：{{ this.initiator }}</p>
        <p class="contract_information">
          发送时间：{{ dataSource.created_at }}
        </p>
        <p class="contract_information">合同状态：{{ this.status }}</p>
        <p class="contract_information">
          签署截止时间：{{ dataSource.expire_at }}
        </p>
      </div>
      <div class="contract_detailBox">
        <p class="contract_title">
          合同详情
          <!-- <span
            class="download-btn"
            v-show="!isiOS && downloadPdfSrc"
            @click="downloadPdf"
            >下载</span
          > -->
        </p>
        <div class="contract_detail" @click="showPdf = true">
          <pdf
            ref="myPdfComponent"
            v-for="(i, j) in numPages"
            :key="j"
            :src="pdfSrc"
            :page="i"
            v-show="pdfSrc"
          ></pdf>
          <div
            v-for="(item, index) in sign_file_urllist"
            :key="index"
            v-show="sign_file_urllist.length"
            class="contranct-img-div"
            @click="showPdfInfo(item)"
          >
            <img :src="item" alt="" />
          </div>
          <!-- <pdf ref="myPdfComponent" v-for="i in numPages" :key="i" :src="pdfSrc" :page="i" style="width: 200%"></pdf> -->
        </div>

        <div class="stepper-warpper" v-if="showPdf">
          <van-stepper
            v-model="value"
            input-width="40px"
            step="0.2"
            :decimal-length="1"
            :disabled="isDisabled"
            @change="stepperOnchange"
          />
          <div class="percent">{{ percentValue }}</div>
        </div>
        <van-popup
          v-model="showPdf"
          closeable
          position="bottom"
          :style="{ height: 'calc(100% - 66px)' }"
        >
          <div :style="pdfStyle" ref="pdfbox" class="pup-img">
            <pdf
              ref="myPdfComponent"
              v-for="(i, j) in numPages"
              :key="j"
              :src="pdfSrc"
              :page="i"
              v-show="pdfSrc"
            ></pdf>
            <img :src="pupimageUrl" alt="" class="pdf-pup-image" />
            <!-- <span
              class="download-btn"
              v-show="!isiOS && pupimageUrl"
              @click="downloadPdf(pupimageUrl)"
              >下载</span
            > -->
          </div>
        </van-popup>
      </div>

      <div class="signed_informationBox">
        <p class="contract_title">签署信息</p>
        <div class="signed_tab">
          <table
            width="100%"
            class="debt_contract_info_table"
            border="1"
            cellspacing="0"
            cellpadding="0"
            bordercolor="#EEEEEE"
            style="text-align: center"
          >
            <thead>
              <tr>
                <th>签署人账号</th>
                <th>签署人名称</th>
                <th>签署人状态</th>
                <th>签署时间</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(user, i) in contract_info"
                :key="user.contract_id + i"
              >
                <td>{{ user.unique_number }}</td>
                <td>{{ user.name }}</td>
                <td>{{ user.sign_at ? "已签署" : "签署中" }}</td>
                <td>{{ user.sign_at }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import dsbridge from "dsbridge";
import pdf from "vue-pdf";
export default {
  name: "electroniContract",
  metaInfo: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes",
      },
    ],
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      showPdf: false,
      contract_info: [],
      dataSource: {},
      initiator: "",
      status: "",
      pdfSrc: "",
      // "http://qiniu.woaidk.top/temporary/20200904054015218.pdf?e=1599534207&token=Tz6xfTsO8aI1vNCJTBqySVi7EvlyUY9nO7poK9Kv:uKbTKyzupxvaAYg1-5ZzPYoFy90=", // pdf文件地址
      numPages: undefined,
      value: 1,
      pdfStyle: {
        "transform-origin": "left top",
      },
      isDisabled: false,
      downloadPdfSrc: "",
      isiOS: false,
      sign_file_urllist: [],
      pupimageUrl: "",
    };
  },
  computed: {
    percentValue() {
      return parseInt(parseFloat(this.value) * 100) + "%";
    },
  },
  created() {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    this.onLoad();
  },
  components: {
    navbar,
    pdf,
  },
  mounted() {},
  methods: {
    showPdfInfo(url) {
      this.showPdf = true;
      this.pupimageUrl = url;
    },
    // 下载pdf
    downloadPdf(urel) {
      let url = urel ? urel : this.downloadPdfSrc;
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        let jsonParams = JSON.stringify({
          key: "url",
          value: url,
        });
        dsbridge.call("downLoadFile", jsonParams, (res) => {
          let json = JSON.parse(res);
          if (json.result == "completed") {
            this.params(json.path, json.path, "openFile");
          } else {
          }
        });
      } else if (isAndroid) {
        this.params(url, url, "downloadStart");
      }
    },
    stepperOnchange() {
      this.$nextTick(() => {
        this.pdfStyle.transform = `scale(${this.value})`;
        this.$refs.pdfbox.style.display = "none";
        this.isDisabled = true;
        setTimeout(() => {
          // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
          this.$refs.pdfbox.style.display = "block";
        }, 10);
        setTimeout(() => {
          this.isDisabled = false;
        }, 200);
      });
    },
    onLoad() {
      let url = "investment/member/agent/order/contract/template/detail";
      let params = {
        ordersn: this.$route.query.ordersn,
      };
      this.$api
        .post(url, params)
        .then((data) => {
          this.contract_info = data.contract_role_info;
          this.dataSource = data;
          if (data.sign_file_url && data.sign_file_url.constructor === Array) {
            this.sign_file_urllist = data.sign_file_url;
          } else {
            if (data.sign_file_url) {
              this.pdfSrc =
                location.protocol + "//" + data.sign_file_url.split("//")[1];
            }
            this.downloadPdfSrc = this.pdfSrc;
            if (data.sign_file_url) {
              this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
              this.pdfSrc.promise.then((pdf) => {
                this.numPages = pdf.numPages;
              });
            }
          }
          this.contract_info.map((item) => {
            if (item.role_type === 1) {
              this.initiator = item.name;
            }
          });
          switch (data.contract_status) {
            case -4:
              this.status = "已作废";
              break;
            case -3:
              this.status = "已失效";
              break;
            case -2:
              this.status = "已撤回";
              break;
            case -1:
              this.status = "已驳回";
              break;
            case 0:
              this.status = "待审批";
              break;
            case 1:
              this.status = "已审批";
              break;
            case 2:
              this.status = "已完成";
              break;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less">
.electroniContract_warpper {
  &::-webkit-scrollbar {
    display: none;
  }

  padding-top: 44px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  color: #333;
  font-size: 14px;
  min-height: 100%;

  // .navbar {
  //   margin: 24px 5px 0 5px;
  // }
  .contentBox {
    width: 100%;
    margin: 0;

    .pdf-box {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      max-width: 1024px;
      width: 100%;
      margin: 0 auto;
      overflow-x: hidden;
      height: 100%;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      font-size: 0.28rem;

      span {
        width: 100%;
      }
    }

    .contract_informationBox {
      background: #fff;
      padding: 15px 12px;
      margin: 12px 0;

      .contract_information {
        font-size: 14px;
        margin: 6px 0 0;
        line-height: 23px;
      }
    }

    .contract_title {
      font-size: 16px;
      font-weight: 600;
      height: 26px;
      line-height: 26px;
      padding-bottom: 3px;
    }

    .contract_detailBox {
      background: #fff;
      padding: 15px 12px 24px;
      margin: 12px 0;

      .contract_detail {
        display: flex;
        flex-wrap: wrap;
        width: 100%;

        .contranct-img-div {
          width: 22%;
          margin-right: 1%;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .pdf-pup-image {
      width: 100vw;
      height: 100%;
    }

    .contract_detail > span {
      width: 24%;
      margin: 6px 1% 0 0;
      height: 99px;

      canvas {
        height: 100% !important;
      }
    }

    .contract_detail > span:last-child {
      margin: 6px 0 0 0;
    }

    .debt_contract_info_table {
      table-layout: fixed;
      /*使table的宽度固定*/
      width: 100%;
      /*给table一个宽度*/
    }

    .signed_informationBox {
      background: #fff;
      padding: 15px 12px;
      margin: 12px 0;

      .signed_tab {
        font-size: 13px;
        margin-top: 6px;

        th,
        td {
          padding: 4px;
          word-wrap: break-word;
          word-break: break-all;
        }

        th {
          color: #999;
          font-weight: 400;
        }
      }
    }
  }

  .van-popup {
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .van-popup__close-icon {
    top: 44px;
  }

  .stepper-warpper {
    height: 28px;
    width: 100%;
    z-index: 9999;
    position: fixed;
    top: 44px;
    left: 50%;
    transform: translate(-50%);
    background-color: #fff;
    color: #000;

    .van-stepper {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    .percent {
      position: absolute;
      height: 28px;
      line-height: 28px;
      width: 40px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      background-color: #f2f3f5;
      font-size: 13px;
    }
  }
}

.download-btn {
  font-weight: 400;
  font-size: 14px;
  color: rgba(18, 111, 255, 1);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 20px;
  text-decoration: none;
  margin-left: 15px;
}

.pup-img {
  .download-btn {
    margin: 10px 10px 0 0;
    float: right;
  }
}
</style>